module.exports = __webpack_public_path__ + "static/media/push-logo.9a747493.svg";